import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface Tenant {
  id: string
  name: string
  slug: string
  domain?: string
  settings: {
    theme: 'light' | 'dark'
    primary_color: string
    logo_url?: string
    currency: string
    timezone: string
    language: string
  }
  subscription_plan: string
  is_active: boolean
  created_at: string
}

interface TenantState {
  currentTenant: Tenant | null
  tenants: Tenant[]
  isLoading: boolean
  error: string | null
}

const initialState: TenantState = {
  currentTenant: null,
  tenants: [],
  isLoading: false,
  error: null,
}

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setCurrentTenant: (state, action: PayloadAction<Tenant>) => {
      state.currentTenant = action.payload
      localStorage.setItem('currentTenant', JSON.stringify(action.payload))
    },
    updateTenantSettings: (state, action: PayloadAction<Partial<Tenant['settings']>>) => {
      if (state.currentTenant) {
        state.currentTenant.settings = {
          ...state.currentTenant.settings,
          ...action.payload,
        }
        localStorage.setItem('currentTenant', JSON.stringify(state.currentTenant))
      }
    },
    setTenants: (state, action: PayloadAction<Tenant[]>) => {
      state.tenants = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
  },
})

export const {
  setCurrentTenant,
  updateTenantSettings,
  setTenants,
  setLoading,
  setError,
} = tenantSlice.actions

export default tenantSlice.reducer
